module.exports = {"533103001":"勐焕街道","533103101":"芒市镇","533103102":"遮放镇","533103103":"勐戛镇","533103104":"芒海镇","533103105":"风平镇","533103201":"轩岗乡","533103202":"江东乡","533103203":"西山乡","533103204":"中山乡","533103205":"三台山乡","533103206":"五岔路乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/533103.json
// module id = 2470
// module chunks = 0